import React, {useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import './index.scss'



export default function Index() {

  useEffect(() => {

    console.log(11111111111, getScrollbarWidth())

  }, [])


  /**
   * 获取滚动条宽度
   */
  const getScrollbarWidth = () => {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;'
    document.body.appendChild(scrollDiv)
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    document.body.removeChild(scrollDiv)
    return scrollbarWidth || 0
  }



  return (
    <div className='aedviser' style={{right: getScrollbarWidth()  + 'px'}}>
      <div className="aedviser-button">
        <div className="aedviser-button-content">
          <div className="aedviser-button-icon-border">
            <div className="aedviser-button-icon">
              <img src='https://pic.001pt.com/imgs/assets/stranger-full2.png' alt=""/>
            </div>
          </div>
          <div className="aedviser-button-text">添加企业顾问了解更多信息</div>
        </div>
      </div>
      <div className="aedviser-modal-border">
        <div className="aedviser-modal">
          <div className="aedviser-modal-title">企业顾问</div>
          <div className="aedviser-modal-content">
            <div className="aedviser-modal-content-tip">
              <div>打开微信扫一扫</div>
              <div>咨询企业顾问，了解更多产品及服务</div>
            </div>
            <div className="aedviser-modal-content-ewm">
              <img src='https://pic.001pt.com/imgs/assets/ljw.png' alt=""/>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}
